const CutthroatStrategy = () => {
  return <div>CutthroatStrategy</div>;
};
export default CutthroatStrategy;
